import { initialCollectionItemDetailsState } from "./CollectionItemDetails/CollectionItemDetailsState";
import { initialCollectionOverviewState } from "./CollectionOverview/CollectionOverviewWidget";
export const lookupBranchId = (nodeId)=>{
    if (!window.nodeToBranch) {
        console.warn('Node-to-branch mapping (window.nodeToBranch) is not available; preferred branch cannot be resolved.');
        return '';
    }
    return window.nodeToBranch[nodeId] || '';
};
export const defaultCollectionConfig = {
    route: window.collectionRoute || '/aanbod',
    excludedBranchIds: []
};
export const initialCollectionApplicationState = ()=>({
        collection: {
            details: initialCollectionItemDetailsState,
            overview: initialCollectionOverviewState()
        }
    });
